import CloseUps from '../../src/legacy/CloseUps.tsx';
export default CloseUps;
